// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__+sim5","container":"main_container__vv249","number":"main_number__Zs7r3","text":"main_text__Acxwv","link":"main_link__NJSuG"};